<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <v-tour name="blogisticTour" :steps="steps" :callbacks="callbacksTour"></v-tour>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()" v-b-tooltip title="Cadastrar"><i class="ft-plus" v-if="getPermission('modelocte.store')"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>

                                    <vuetable ref="vuetable"
                                        api-url="/api/modelocte"
                                        :fields="fields"
                                        :css="css"
                                        :append-params="moreParams"
                                        track-by="modcte_id"
                                        pagination-path=""
                                        @vuetable:pagination-data="onPaginationData"
                                        @vuetable:cell-clicked="onDetail"
                                        @vuetable:loaded="onLoaded"
                                        detail-row-component="modelo-cte-detalhes"
                                      >
                                      <template slot="status" slot-scope="props">
                                          <span class="badge badge-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                          <span class="badge badge-warning" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                        </template>

                                        <template slot="tp_servico" slot-scope="props">
                                            <span class="badge badge-success" v-if="props.rowData.tp_servico.valor==0">Normal</span>
                                            <span class="badge badge-warning" v-if="props.rowData.tp_servico.valor==1">Subcontratação</span>
                                            <span class="badge badge-warning" v-if="props.rowData.tp_servico.valor==2">Redespacho</span>
                                            <span class="badge badge-danger"  v-if="props.rowData.tp_servico.valor==3">Redespacho Intermediário</span>
                                            <span class="badge badge-info" v-if="props.rowData.tp_servico.valor==4">Serviço Vinculado a Multimodal</span>
                                          </template>

                                          <template slot="tomador" slot-scope="props">
                                              <span v-if="props.rowData.pessoa_tom!==null">{{ props.rowData.pessoa_tom.pessoa_juridica.razao_social }}<br>{{ onFormataCnpj(props.rowData.pessoa_tom.pessoa_juridica.cnpj_base,props.rowData.pessoa_tom.pessoa_juridica.cnpj_filial,props.rowData.pessoa_tom.pessoa_juridica.cnpj_digito)}}</span>
                                            </template>

                                      <template slot="actions" slot-scope="props">
                                        <span v-if="getPermission('modelocte.update')">
                                            <a @click="onEdit(props.rowData)"v-b-tooltip title="Editar Modelo"><i class="fa fa-edit"></i></a>
                                        </span>
                                        <div class="custom-actions">
                                            <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                        </div>
                                      </template>
                                  </vuetable>
                              </div>
                                <div>
                                    <div class='col-md-12'>
                                        <div class="pull-left pagination-detail">
                                            <vuetable-pagination-info ref="paginationInfo"
                                                                      :css="css.pagination"
                                                                      info-class="pull-left"
                                            ></vuetable-pagination-info>
                                        </div>
                                        <div class="pull-right m-a-0">
                                            <vuetable-pagination ref="pagination"
                                                                 :css="css.pagination"
                                                                 @vuetable-pagination:change-page="onChangePage"
                                            ></vuetable-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Modal Component -->
            <b-modal id="modal_form"
                     ref="modal_form"
                     size="lg"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     v-model="showModal"
                     :ok-disabled=form.errors.any()
                     @ok="handleOk">
                <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
                    <b-container fluid class="p-a-0">
                      <b-row>
                        <b-col>
                          <label>Descrição</label>
                            <b-form-input type="text"
                                          placeholder="Descrição do modelo"
                                          v-model="form.descr"
                                          >
                            </b-form-input>
                            <b-form-feedback class="text-danger" v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>
                        </b-col>
                    </b-row>
                        <b-row>
                          <b-col>
                              <label>CST</label>
                              <multiselect v-model="form.cst"
                              :options="optionsCst"
                              track-by="value"
                              label="label"
                              :hide-selected="true"
                              placeholder="Selecione"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('cst.value')" v-if="form.errors.has('cst.value')"></b-form-feedback>
                          </b-col>

                            <b-col class="p-l-0">
                                <label>CFOP</label>
                                <multiselect v-model="form.cfop"
                                :options="optionsCfop"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                                ></multiselect>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('cfop.value')" v-if="form.errors.has('cfop.value')"></b-form-feedback>
                            </b-col>

                            <b-col class="p-l-0">
                                <label>Tipo serviço *</label>
                                <multiselect v-model="form.tp_servico"
                                :options="optionsLivTpServico"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                                ></multiselect>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('tp_servico.value')" v-if="form.errors.has('tp_servico.value')"></b-form-feedback>
                            </b-col>

                            <b-col class="p-l-0">
                              <label>Valor Carga * <span v-b-tooltip title="Indica o valor da NF a ser utilizado no campo Valor da Carga do CTE" placement="top">[?]</span></label>
                              <multiselect v-model="form.tp_valor_carga"
                              :options="optionsLivTpValorCarga"
                              track-by="value"
                              label="label"
                              :hide-selected="true"
                              placeholder="Selecione"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('tp_valor_carga.value')" v-if="form.errors.has('tp_valor_carga.value')"></b-form-feedback>
                            </b-col>

                            <b-col class="p-l-0">
                              <label>Globalizado * <span v-b-tooltip title="Caso seja SIM, o literal diversos será usado no destinatário e vários Destinatário serão possíveis no CTE" placement="top">[?]</span></label>
                              <multiselect v-model="form.globalizado"
                              :options="optionsLivGlobalizado"
                              track-by="value"
                              label="label"
                              :hide-selected="true"
                              placeholder="Selecione"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('globalizado.value')" v-if="form.errors.has('globalizado.value')"></b-form-feedback>
                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col>
                                <label>Municipio Inicio</label>
                                <multiselect v-model="form.municipioini"
                                :options="optionsMunicipioIni"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                                ></multiselect>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('municipioini.value')" v-if="form.errors.has('municipioini.value')"></b-form-feedback>
                            </b-col>

                            <b-col class="p-l-0">
                                <label>Municipio Fim</label>
                                <multiselect v-model="form.municipiofim"
                                :options="optionsMunicipioFim"
                                track-by="value"
                                label="label"
                                :hide-selected="true"
                                placeholder="Selecione"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                                ></multiselect>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('municipiofim.value')" v-if="form.errors.has('municipiofim.value')"></b-form-feedback>
                            </b-col>
                            <b-col class="p-l-0">
                              <label>Valor Averbação</label>
                                <b-form-input type="text"
                                              v-money="vlr"
                                              placeholder="Valor Averbação"
                                              v-model="form.vlr_carga_averbacao"
                                              >
                                </b-form-input>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_carga_averbacao')" v-if="form.errors.has('vlr_carga_averbacao')"></b-form-feedback>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <label>Produto Predominante</label>
                                <b-form-input type="text"
                                            placeholder="Produto Predominante"
                                            v-model="form.produto_predominante"
                                            name="cst"
                                            >
                                </b-form-input>
                                <b-form-feedback class="text-danger" v-text="form.errors.get('produto_predominante')" v-if="form.errors.has('produto_predominante')"></b-form-feedback>
                            </b-col>
                        </b-row><br>
                        <b-row>
                          <b-col>
                            <b-form-textarea id="textarea1"
                                             name="obs"
                                             v-model="form.obs"
                                             placeholder="Observação"
                                             :rows="6"
                                             :max-rows="6">
                            </b-form-textarea>
                            <b-form-feedback class="text-danger" v-text="form.errors.get('obs')" v-if="form.errors.has('obs')"></b-form-feedback>
                          </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <br/>
                                <h3 class="panel-title with-border">Valores</h3>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <label>Valor Liquido</label>
                                <input v-model.lazy="form.vlr_cte"
                                     v-money="vlr"
                                     v-on:keyup="calcCte"
                                     name="vlr_cte"
                                     type="text"
                                     class="form-control"
                                     style="text-align: right" />
                                <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_cte')" v-if="form.errors.has('vlr_cte')"></b-form-feedback>
                            </b-col>
                            <b-col>
                                <label>Alíquota</label>
                                <input v-model.lazy="form.vlr_aliquota"
                                       v-money="aliquota"
                                       v-on:keyup="calcCte"
                                       name="vlr_aliquota"
                                       type="text"
                                       class="form-control"
                                       style="text-align: right" />
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_aliquota')" v-if="form.errors.has('vlr_aliquota')"></b-form-feedback>
                            </b-col>
                            <b-col>
                                <label>Imposto</label>
                                <input v-model.lazy="form.vlr_imposto"
                                     v-money="vlr"
                                     name="vlr_imposto"
                                     type="text"
                                     class="form-control"
                                     style="text-align: right" />
                                <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_imposto')" v-if="form.errors.has('vlr_imposto')"></b-form-feedback>
                            </b-col>

                            <b-col v-if="form.cst==90 || form.cst==20">
                                <label>% Redução BC</label>
                                <input v-model.lazy="form.percentual_reducao_bc"
                                       v-money="percentual_reducao_bc"
                                       name="percentual_reducao_bc"
                                       type="text"
                                       class="form-control"
                                       style="text-align: right" />
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('percentual_reducao_bc')" v-if="form.errors.has('percentual_reducao_bc')"></b-form-feedback>
                              </b-col>

                         <b-col>
                            <label>Valor Total do CTE</label>
                            <input v-model.lazy="form.vlr_total"
                                   v-money="vlr"
                                   name="vlr_total"
                                   type="text"
                                   class="form-control"
                                   readonly="true"
                                   style="text-align: right" />
                              <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_total')" v-if="form.errors.has('vlr_total')"></b-form-feedback>
                          </b-col>
                        </b-row>

                    </b-container>

                    <div v-if="this.form.modal==3">
                        <b-row>
                            <b-col>
                                <br/>
                                <h3 class="panel-title with-border">CTE <b-badge> Aquaviário </b-badge></h3>
                            </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                              <label>Porto de Origem</label>
                              <multiselect v-model="form.porto_origem"
                              :options="optionsPortoOrigem"
                              track-by="value"
                              label="label"
                              :hide-selected="true"
                              placeholder="Selecione"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('porto_origem.value')" v-if="form.errors.has('porto_origem.value')"></b-form-feedback>
                            </b-col>
                            <b-col>

                              <label>Porto de Transbordo</label>
                              <multiselect v-model="form.porto_transbordo"
                              :options="optionsPortoTransbordo"
                              track-by="value"
                              label="label"
                              :hide-selected="true"
                              placeholder="Selecione"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('porto_transbordo.value')" v-if="form.errors.has('porto_transbordo.value')"></b-form-feedback>
                            </b-col>
                            <b-col>

                              <label>Porto de Destino</label>
                              <multiselect v-model="form.porto_destino"
                              :options="optionsPortoDestino"
                              track-by="value"
                              label="label"
                              :hide-selected="true"
                              placeholder="Selecione"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('porto_destino.value')" v-if="form.errors.has('porto_destino.value')"></b-form-feedback>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col>
                              <label>Embarcação</label>
                              <multiselect v-model="form.embarcacao"
                              :options="optionsEmbarcacao"
                              track-by="value"
                              label="label"
                              :hide-selected="true"
                              placeholder="Selecione"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                              ></multiselect>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('embarcacao.value')" v-if="form.errors.has('embarcacao.value')"></b-form-feedback>
                            </b-col>
                          <b-col>
                              <label>Número da Viagem</label>
                              <b-form-input type="text"
                                            placeholder="Número da Viagem"
                                            v-model="form.num_viagem"
                                            name="num_viagem"
                                            >
                              </b-form-input>
                              <b-form-feedback class="text-danger" v-text="form.errors.get('num_viagem')" v-if="form.errors.has('num_viagem')"></b-form-feedback>
                        </b-col>
                        <b-col>
                            <label>% Afrmm</label>
                            <input v-model.lazy="form.vlr_aliquota_afrmm"
                               v-money="aliquota"
                               name="vlr_aliquota_afrmm"
                               type="text"
                               class="form-control"
                               style="text-align: right" />
                            <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_aliquota_afrmm')" v-if="form.errors.has('vlr_aliquota_afrmm')"></b-form-feedback>
                        </b-col>
                    </b-row>
                  </div>
                    <b-container fluid class="p-a-0">
                      <b-row>
                        <b-col>
                            <br/>
                            <h3 class="panel-title">Detalhes do CTE </h3>
                            <b-tabs>
                              <b-tab title="Partes Envolvidas" active>
                                <b-row>
                                    <b-col>
                                      <label>Remetente</label>
                                      <multiselect v-model="form.remetente"
                                      :options-limit="300"
                                      :limit="2"
                                      :limit-text="limitText"
                                      :options="optionsRemetente"
                                      track-by="value"
                                      label="label"
                                      :hide-selected="true"
                                      placeholder="Remetente ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                                      tag-placeholder="Selecionar"
                                      select-label="Selecionar"
                                      selected-label="Selecionado"
                                      deselect-label="Remover"
                                      :searchable="true"
                                      :loading="isLoadingRec"
                                      @search-change="listaClientesRemetente"
                                      ></multiselect>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('remetente')" v-if="form.errors.has('remetente')"></b-form-feedback>
                                    </b-col>
                                </b-row>
                                  <b-row>
                                      <b-col>
                                        <label>Expedidor</label>
                                        <multiselect v-model="form.expedidor"
                                        :options-limit="300"
                                        :limit="2"
                                        :limit-text="limitText"
                                        :options="optionsExpedidor"
                                        track-by="value"
                                        label="label"
                                        :hide-selected="true"
                                        placeholder="Expedidor ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                                        tag-placeholder="Selecionar"
                                        select-label="Selecionar"
                                        selected-label="Selecionado"
                                        deselect-label="Remover"
                                        :searchable="true"
                                        :loading="isLoadingExp"
                                        @search-change="listaClientesExpedidor"
                                        ></multiselect>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('expedidor')" v-if="form.errors.has('expedidor')"></b-form-feedback>
                                      </b-col>
                                  </b-row>
                                  <b-row>
                                      <b-col>
                                        <label>Destinatário</label>
                                        <multiselect v-model="form.destinatario"
                                        :options-limit="300"
                                        :limit="2"
                                        :limit-text="limitText"
                                        :options="optionsDestinatario"
                                        track-by="value"
                                        label="label"
                                        :hide-selected="true"
                                        placeholder="Destinatário ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                                        tag-placeholder="Selecionar"
                                        select-label="Selecionar"
                                        selected-label="Selecionado"
                                        deselect-label="Remover"
                                        :searchable="true"
                                        :loading="isLoadingRec"
                                        @search-change="listaClientesDestinatario"
                                        ></multiselect>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('destinatario')" v-if="form.errors.has('destinatario')"></b-form-feedback>
                                      </b-col>
                                  </b-row>
                                  <b-row>
                                      <b-col>
                                        <label>Recebedor</label>
                                        <multiselect v-model="form.recebedor"
                                        :options-limit="300"
                                        :limit="2"
                                        :limit-text="limitText"
                                        :options="optionsRecebedor"
                                        track-by="value"
                                        label="label"
                                        :hide-selected="true"
                                        placeholder="Recebedor ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                                        tag-placeholder="Selecionar"
                                        select-label="Selecionar"
                                        selected-label="Selecionado"
                                        deselect-label="Remover"
                                        :searchable="true"
                                        :loading="isLoadingRec"
                                        @search-change="listaClientesRecebedor"
                                        ></multiselect>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('recebedor')" v-if="form.errors.has('recebedor')"></b-form-feedback>
                                      </b-col>
                                  </b-row>
                                  <b-row>
                                      <b-col>
                                        <label>Tomador</label>
                                        <multiselect v-model="form.tomador_outros"
                                        :options-limit="300"
                                        :limit="2"
                                        :limit-text="limitText"
                                        :options="optionsTomador"
                                        track-by="value"
                                        label="label"
                                        :hide-selected="true"
                                        placeholder="Tomador ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                                        tag-placeholder="Selecionar"
                                        select-label="Selecionar"
                                        selected-label="Selecionado"
                                        deselect-label="Remover"
                                        :searchable="true"
                                        :loading="isLoadingTom"
                                        @search-change="listaClientesTomador"
                                        ></multiselect>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('tomador_outros.value')" v-if="form.errors.has('tomador_outros.value')"></b-form-feedback>
                                      </b-col>
                                  </b-row>

                                  <b-row>
                                      <b-col>
                                          <label>Tomador Outros</label>
                                            <b-form-radio-group buttons button-variant="secondary" v-model="form.tomador" name="tomador">
                                              <b-form-radio value="0">Remetente</b-form-radio>
                                              <b-form-radio value="1">Expedidor</b-form-radio>
                                              <b-form-radio value="2">Recebedor</b-form-radio>
                                              <b-form-radio value="3">Destinatário</b-form-radio>
                                              <b-form-radio value="4">Outros</b-form-radio>
                                            </b-form-radio-group>
                                            <b-form-feedback class="text-danger" v-text="form.errors.get('tomador')" v-if="form.errors.has('tomador')"></b-form-feedback>
                                        </b-col>
                                    </b-row>
                              </b-tab>
                              <b-tab title="Carga">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th style="width: 30%">Unidade de medida*</th>
                                            <th style="width: 30%">Tipo de medida</th>
                                            <th style="width: 30%">Quantidade carga</th>
                                            <th style="width: 10%">Ações</th>
                                        </tr>
                                     </thead>
                                     <tbody>
                                         <tr v-for="(row, index) in carga" class="bg-gray-light" style="display: table-row;">
                                            <td>
                                              <b-col>
                                                  <multiselect v-model="row.medida"
                                                  :options="optionsParamUnidadeMedida"
                                                  track-by="value"
                                                  label="label"
                                                  :hide-selected="true"
                                                  placeholder="Selecione"
                                                  tag-placeholder="Selecionar"
                                                  select-label="Selecionar"
                                                  selected-label="Selecionado"
                                                  deselect-label="Remover"
                                                  ></multiselect>
                                                  <b-form-feedback class="text-danger" v-text="form.errors.get('carga.'+index+'.medida.value')" v-if="form.errors.has('carga.'+index+'.medida.value')"></b-form-feedback>
                                              </b-col>
                                            </td>
                                            <td>
                                              <b-col>
                                                  <multiselect v-model="row.tipomedida"
                                                  :options="optionsParamTipoMedida"
                                                  track-by="value"
                                                  label="label"
                                                  :hide-selected="true"
                                                  placeholder="Selecione"
                                                  tag-placeholder="Selecionar"
                                                  select-label="Selecionar"
                                                  selected-label="Selecionado"
                                                  deselect-label="Remover"
                                                  ></multiselect>
                                                  <b-form-feedback class="text-danger" v-text="form.errors.get('carga.'+index+'.tipomedida.value')" v-if="form.errors.has('carga.'+index+'.tipomedida.value')"></b-form-feedback>
                                              </b-col>
                                            </td>
                                            <td>
                                              <b-col>
                                                  <b-form-input type="text"
                                                                placeholder=""
                                                                v-model="row.qtde_carga"
                                                                >
                                                  </b-form-input>
                                                  <b-form-feedback class="text-danger" v-text="form.errors.get('carga.'+index+'.qtde_carga')" v-if="form.errors.has('carga.'+index+'.qtde_carga')"></b-form-feedback>
                                              </b-col>
                                            </td>
                                            <td>
                                                  <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowCarga(index);"></i>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <td></td><td></td><td></td>
                                    <td>
                                      <i class="fa fa-plus-square" v-on:click="addRowCarga($event);" v-b-tooltip.hover.right="'Adicionar Linha'" style="cursor: pointer"></i>
                                    </td>
                                </table>
                              </b-tab>
                              <b-tab title="Seguro">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th style="width: 45%">Responsável pelo seguro*</th>
                                            <th style="width: 45%">Seguradora</th>
                                            <th style="width: 5%">Ações</th>
                                        </tr>
                                     </thead>
                                     <tbody>
                                         <tr v-for="(row, index) in seguro">
                                            <td>
                                              <b-col>
                                                  <multiselect v-model="row.respseg"
                                                  :options="optionsParamRespSeg"
                                                  track-by="value"
                                                  label="label"
                                                  :hide-selected="true"
                                                  placeholder="Selecione"
                                                  tag-placeholder="Selecionar"
                                                  select-label="Selecionar"
                                                  selected-label="Selecionado"
                                                  deselect-label="Remover"
                                                  ></multiselect>
                                                  <b-form-feedback class="text-danger" v-text="form.errors.get('seguro.'+index+'.respseg.value')" v-if="form.errors.has('seguro.'+index+'.respseg.value')"></b-form-feedback>
                                              </b-col>
                                            </td>
                                            <td>
                                              <multiselect v-model="row.seguradora"
                                              :options="optionsSeguradora"
                                              track-by="value"
                                              label="label"
                                              :hide-selected="true"
                                              placeholder="Selecione"
                                              tag-placeholder="Selecionar"
                                              select-label="Selecionar"
                                              selected-label="Selecionado"
                                              deselect-label="Remover"
                                              ></multiselect>
                                              <b-form-feedback class="text-danger" v-text="form.errors.get('seguro.'+index+'.seguradora.value')" v-if="form.errors.has('seguro.'+index+'.seguradora.value')"></b-form-feedback>
                                            </td>
                                            <td>
                                                <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowSeguro(index);"></i>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <td></td><td></td>
                                    <td>
                                      <i class="fa fa-plus-square" v-on:click="addRowSeguro($event);" v-b-tooltip.hover.right="'Adicionar Linha'" style="cursor: pointer"></i>
                                    </td>
                                </table>
                              </b-tab>
                              <b-tab title="Comp. Frete" >
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th style="width: 45%">Componente</th>
                                            <th style="width: 45%">Valor</th>
                                            <th style="width: 10%">Ações</th>
                                        </tr>
                                     </thead>
                                     <tbody>
                                         <tr v-for="(row, index) in comp_frete">
                                            <td>
                                                <multiselect v-model="row.custo"
                                                :options="optionsCustos"
                                                track-by="value"
                                                label="label"
                                                :hide-selected="true"
                                                placeholder="Selecione"
                                                tag-placeholder="Selecionar"
                                                select-label="Selecionar"
                                                selected-label="Selecionado"
                                                deselect-label="Remover"
                                                ></multiselect>
                                                <b-form-feedback class="text-danger" v-text="form.errors.get('comp_frete.'+index+'.custo.value')" v-if="form.errors.has('comp_frete.'+index+'.custo.value')"></b-form-feedback>
                                            </td>
                                            <td>
                                              <b-col>
                                                  <b-form-input type="text"
                                                              placeholder="Valor"
                                                              v-model="row.vlr"
                                                              >
                                                  </b-form-input>
                                                  <b-form-feedback class="text-danger" v-text="form.errors.get('comp_frete.'+index+'.vlr')" v-if="form.errors.has('comp_frete.'+index+'.vlr')"></b-form-feedback>
                                              </b-col>
                                            </td>
                                            <td>
                                                  <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowCompFrete(index);"></i>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <td></td><td></td>
                                    <td>
                                      <i class="fa fa-plus-square" v-on:click="addRowCompFrete($event);" v-b-tooltip.hover.right="'Adicionar Linha'" style="cursor: pointer"></i>
                                    </td>
                                </table>
                              </b-tab>
                            </b-tabs>
                        </b-col>
                      </b-row>
                   </b-container fluid class="p-a-0">
                 </form>

                <div slot="modal-footer" class="w-100">
                       <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                       <div class="float-right">
                         <div class="float-left" v-if="this.errors_array.length>0">
                         <b-btn class="badge badge-warning" @click="showPopover = !showPopover" id="popoverButton-sync" v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'" variant="warning"><i class="fa fa-exclamation-triangle fa-2x"></i></b-btn>

                         <b-popover :show.sync="showPopover" target="popoverButton-sync" title="<strong>Erros Encontrados</strong>" data-html="true" placement="leftbottom">
                           <table class="table" id="mais">
                                <tbody>
                                    <tr class="bg-gray-light" style="display: table-row;" v-for="item in this.errors_array">
                                       <td>
                                         {{ item.erro }}
                                       </td>
                                   </tr>
                               </tbody>
                           </table>
                         </b-popover>
                       </div>
                       &nbsp;

                           <b-btn @click="showModal=false" variant="secondary">
                             Fechar
                           </b-btn>
                           <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                             Enviar
                           </b-btn>
                       </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import ModeloCteFilterBar from './ModeloCteFilterBar'
import ModeloCteDetalhes from './ModeloCteDetalhes'
import {VMoney} from 'v-money'
import accounting from 'accounting'
import moment from 'moment'
Vue.component('modelo-cte-detalhes', ModeloCteDetalhes);

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        'vuetable-filterbar': ModeloCteFilterBar,
        VMoney,
    },
    data () {
        return {
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          loading: false,
          isDisabled: false,
          loadingData: true,
          showModal: false,
          showModalSelect: false,
          showModalSel: false,
          showPopover: false,
          optionsParamMotivo: [],
          optionsExpedidor: [],
          optionsRemetente: [],
          optionsDestinatario: [],
          optionsRecebedor: [],
          optionsTomador: [],
          optionsCfop: [],
          optionsLivTpServico: [],
          isLoadingExp: false,
          isLoadingRec: false,
          isLoadingTom: false,
          isFullscreen: false,
          helpForm: new Form({statusRecord: [], params: [], search:''}),
          vn_vlr_cte: 0,
          vn_aliquota: 0,
          vn_percentual_reducao_bc: 0,
          activateDesativate: [],
          optionsMunicipioIni: [],
          optionsMunicipioFim: [],
          optionsPortoOrigem: [],
          optionsPortoTransbordo: [],
          optionsPortoDestino: [],
          optionsPortoOrigem: [],
          optionsEmbarcacao: [],
          optionsParamUnidadeMedida: [],
          optionsParamTipoMedida: [],
          optionsParamRespSeg: [],
          optionsSeguradora: [],
          optionsCustos: [],
          optionsCst: [],
          optionsLivTpValorCarga: [],
          optionsLivGlobalizado: [],
          obs_cont: [],
          obs_fisco: [],
          errors_array: [],
          carga: [ { medida: [],
                     tipomedida: [],
                     qtde_carga: '',
                     modcte_id: ''
                 }],
          seguro: [ { respseg: [],
                      seguradora: []
                  }],
          comp_frete: [ { nome: '',
                      vlr: ''}],
          vlr: {
              decimal: ',',
              thousands: '.',
              prefix: 'R$ ',
              precision: 2,
              masked: false /* doesn't work with directive */
          },
          percentual_reducao_bc: {
              decimal: ',',
              prefix: '% ',
              precision: 2,
              masked: false /* doesn't work with directive */
          },
          aliquota: {
              decimal: ',',
              prefix: '% ',
              precision: 2,
              masked: false /* doesn't work with directive */
          },
          qtd: {
              decimal: ',',
              thousands: '.',
              precision: 2,
              masked: false /* doesn't work with directive */
          },
          form: new Form({
                    cst: [],
                    descr: '',
                    cfop: [],
                    tp_servico: [],
                    tp_cte: 0,
                    municipioini: [],
                    municipiofim: [],
                    tp_valor_carga: [],
                    globalizado: [],
                    produto_predominante: '',
                    vlr_cte: '',
                    vlr_carga_averbacao: '',
                    vlr_aliquota: 0,
                    vlr_imposto: 0,
                    vlr_total: 0,
                    percentual_reducao_bc: 0,
                    porto_origem: [],
                    porto_transbordo: [],
                    porto_destino: [],
                    embarcacao: [],
                    num_viagem: '',
                    recebedor: [],
                    expedidor: [],
                    remetente: [],
                    destinatario: [],
                    tomador: '',
                    tomador_outros: [],
                    obs: '',
                    vlr_aliquota_afrmm: '',
                    modal: '',
                    carga: [],
                    seguro: [],
                    obs_cont: [],
                    obs_fisco: [],
                    comp_frete: [],
                    modcte_id: ''
                }),
          fields: [
            {
                name: '__checkbox',
                titleClass: 'center aligned',
                dataClass: 'center aligned'
            },
            {
              name: 'cd',
              title: 'Código'
            },
            {
              name: 'descr',
              title: 'Descrição'
            },
            {
              name: 'municipio_inicio.nome',
              title: 'Município de Início'
            },
            {
              name: 'municipio_fim.nome',
              title: 'Município de Fim'
            },
            {
              name: 'vlr_cte',
              title: 'Valor CTE',
              callback: 'formatNumber'
            },
            {
              name: '__slot:status',
              title: 'Status'
            },
            {
              name: '__slot:tp_servico',
              title: 'Serviço'
            },
            {
              name: '__slot:tomador',
              title: 'Tomador'
            },
            {
              name: '__slot:actions',
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
            }
        ],
        css: {
            tableClass: 'table table-striped',
            loadingClass: 'loading',
            ascendingIcon: 'glyphicon glyphicon-chevron-up',
            descendingIcon: 'glyphicon glyphicon-chevron-down',
            handleIcon: 'glyphicon glyphicon-menu-hamburger',
            detailRowClass: 'vuetable-detail-row',
        },
        moreParams: {}
       }
    },
    directives: {
        money: VMoney,
        aliquota: VMoney,
        qtd: VMoney,
        percentual_reducao_bc: VMoney
    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
        this.getLivGeral();
      },
    methods: {
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onFilterSet (data_filter) {
            this.moreParams = {
                'cd':  data_filter.cd,
                'descr':  data_filter.descr,
                'municipio_inicio': data_filter.municipio_inicio.value,
                'municipio_fim': data_filter.municipio_fim.value,
                'tp_servico': data_filter.tp_servico.value,
                'status': data_filter.status.value,
                'tom_cnpj': data_filter.tom_cnpj

            }
            Vue.nextTick( () => this.$refs.vuetable.reload())
        },
        onFilterReset () {
            this.loadingData = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingData = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        onDetail (data, field, event) {
            this.$refs.vuetable.toggleDetailRow(data.modcte_id);
        },
        formatDate (value, fmt = 'D MMM YYYY HH:mm') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DD HH:mm').format(fmt)
        },
        formatNumber (value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        formatNumberCarga (value) {
            return accounting.formatNumber(value, 3, '.', ',')
        },
        handleOk(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStore();
            }
            else
            {
                this.onUpdate(e);
            }
        },
        onCreate (data) {
            this.modal_titulo = "Gerar Modelo";
            this.modal_botao = "Gerar Modelo";
            this.modal_acao = "i";
            this.loading = false;
            this.isDisabled = false;
            //this.form.reset();
            this.$refs.modal_form.show();
        },
        calcCte() {
            this.vn_vlr_cte = this.form.vlr_cte.replace( ".", "" );
            this.vn_vlr_cte = this.vn_vlr_cte.replace( ",", "." );
            this.vn_vlr_cte = parseFloat( this.vn_vlr_cte.replace(/[^0-9.]/g, "") );

            this.vn_aliquota = this.form.vlr_aliquota.replace( ".", "" );
            this.vn_aliquota = this.vn_aliquota.replace( ",", "." );
            this.vn_aliquota = parseFloat( this.vn_aliquota.replace( /[^0-9.]/g, "") );

            this.form.vlr_imposto = Number((this.vn_vlr_cte/((100-this.vn_aliquota)/100))-this.vn_vlr_cte).toFixed(2);

            this.vn_vlr_total = parseFloat(this.vn_vlr_cte)+parseFloat(this.form.vlr_imposto);
            this.form.vlr_total = Number(this.vn_vlr_total).toFixed(2);
            // this.form.vlr_imposto = this.vn_vlr_cte*(this.vn_aliquota).toFixed(2);
        },
        onEdit (data)
        {
          this.isDisabled = false;
          this.loading = false;
          this.modal_titulo = "Alterar";
          this.modal_botao = "Alterar";
          this.modal_acao = "u";
          this.form.reset();
          this.form.descr = data.descr;
          this.form.cst = {label: data.param_cst.cd+" - "+data.param_cst.descr, value: data.param_cst.parcst_id};
          this.form.cfop = {label: data.cfop.cd+" - "+data.cfop.descr, value: data.cfop.cfop_id};
          this.form.tp_servico = {label: data.tp_servico.descr, value: data.tp_servico.valor};
          this.form.globalizado = {label: data.globalizado.descr, value: data.globalizado.valor};
          this.form.tp_valor_carga = {label: data.tp_valor_carga.descr, value: data.tp_valor_carga.valor};
          this.form.municipioini = {label: data.municipio_inicio.nome, value: data.municipio_inicio.municipio_id};
          this.form.municipiofim = {label: data.municipio_fim.nome, value: data.municipio_fim.municipio_id};
          this.form.produto_predominante = data.produto_predominante;
          this.form.vlr_cte = this.formatNumber(data.vlr_cte);
          this.form.vlr_carga_averbacao = this.formatNumber(data.vlr_averbacao);
          this.form.vlr_aliquota = this.formatNumber(data.aliquota_icms);
          this.form.vlr_imposto = this.formatNumber(data.vlr_imposto);
          this.form.vlr_aliquota_afrmm = this.formatNumber(data.vlr_aliquota_afrmm);
          this.form.percentual_reducao_bc = this.formatNumber(data.percentual_reducao_bc);
          this.form.tomador = data.tomador;
          this.form.obs = data.obs;

          if (data.pessoa_exp!==null)
          {
             this.form.expedidor = { label:data.pessoa_exp.pessoa_juridica.nome_fantasia+" - "+this.onFormataCnpj(data.pessoa_exp.pessoa_juridica.cnpj_base,data.pessoa_exp.pessoa_juridica.cnpj_filial,data.pessoa_exp.pessoa_juridica.cnpj_digito)+" - "+data.pessoa_exp.pessoa_juridica.inscricao_estadual, value: data.pessoa_exp.pessoa_juridica.pessoa_id };
          }

          if (data.pessoa_rec!==null)
          {
             this.form.recebedor = { label:data.pessoa_rec.pessoa_juridica.nome_fantasia+" - "+this.onFormataCnpj(data.pessoa_rec.pessoa_juridica.cnpj_base,data.pessoa_rec.pessoa_juridica.cnpj_filial,data.pessoa_rec.pessoa_juridica.cnpj_digito)+" - "+data.pessoa_rec.pessoa_juridica.inscricao_estadual, value: data.pessoa_rec.pessoa_juridica.pessoa_id };
          }

          if (data.pessoa_rem!==null)
          {
             this.form.tomador_outros = { label:data.pessoa_rem.pessoa_juridica.nome_fantasia+" - "+this.onFormataCnpj(data.pessoa_rem.pessoa_juridica.cnpj_base,data.pessoa_rem.pessoa_juridica.cnpj_filial,data.pessoa_rem.pessoa_juridica.cnpj_digito)+" - "+data.pessoa_rem.pessoa_juridica.inscricao_estadual, value: data.pessoa_rem.pessoa_juridica.pessoa_id };
          }

          if (data.pessoa_rem!==null)
          {
             this.form.remetente = { label:data.pessoa_rem.pessoa_juridica.nome_fantasia+" - "+this.onFormataCnpj(data.pessoa_rem.pessoa_juridica.cnpj_base,data.pessoa_rem.pessoa_juridica.cnpj_filial,data.pessoa_rem.pessoa_juridica.cnpj_digito)+" - "+data.pessoa_rem.pessoa_juridica.inscricao_estadual, value: data.pessoa_rem.pessoa_juridica.pessoa_id };
          }

          if (data.pessoa_des!==null)
          {
             this.form.destinatario = { label:data.pessoa_des.pessoa_juridica.nome_fantasia+" - "+this.onFormataCnpj(data.pessoa_des.pessoa_juridica.cnpj_base,data.pessoa_des.pessoa_juridica.cnpj_filial,data.pessoa_des.pessoa_juridica.cnpj_digito)+" - "+data.pessoa_des.pessoa_juridica.inscricao_estadual, value: data.pessoa_des.pessoa_juridica.pessoa_id };
          }

          if (data.pessoa_tom!==null)
          {
             this.form.tomador_outros = { label:data.pessoa_tom.pessoa_juridica.nome_fantasia+" - "+this.onFormataCnpj(data.pessoa_tom.pessoa_juridica.cnpj_base,data.pessoa_tom.pessoa_juridica.cnpj_filial,data.pessoa_tom.pessoa_juridica.cnpj_digito)+" - "+data.pessoa_tom.pessoa_juridica.inscricao_estadual, value: data.pessoa_tom.pessoa_juridica.pessoa_id };
          }

          this.carga = null;
          this.carga = [];
          data.modelo_cte_carga.forEach((obj)=>{
              this.carga.push({ qtde_carga: this.formatNumberCarga(obj.qtd), medida: {label: obj.param_unidade_medida.descr, value: obj.param_unidade_medida.parunidmed_id }, tipomedida: {label: obj.param_tipo_medida.descr, value: obj.param_tipo_medida.partpmed_id} })
          });

          this.comp_frete = null;
          this.comp_frete = [];
          data.modelo_cte_comp_frete.forEach((obj)=>{
              this.comp_frete.push({ custo: {label: obj.custo.descr, value: obj.custo.custo_id}, vlr: this.formatNumber(obj.vlr) })
          });

          this.seguro = null;
          this.seguro = [];
          data.modelo_cte_seguro.forEach((obj)=>{
              this.seguro.push({ respseg: {label: obj.param_tipo_resp_seg.descr, value: obj.param_tipo_resp_seg.partprese_id}, seguradora: {label: obj.seguradora.nome, value: obj.seguradora.segurado_id} })
          });
          this.modcte_id = data.modcte_id;
          this.calcCte();
          this.$refs.modal_form.show();
        },
        onStore() {
            this.loading = true;
            this.isDisabled = true;
            this.form.carga = this.carga;
            this.form.seguro = this.seguro;
            this.form.obs_cont = this.obs_cont;
            this.form.obs_fisco = this.obs_fisco;
            this.form.comp_frete = this.comp_frete;
            this.form.post('/api/modelocte/store').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {

                new ReturnApi(errors, this)
                this.errors_array = '';
                this.errors_array = [];
                for(var property in errors)
                {
                  if(errors.hasOwnProperty(property))
                  {
                     if(typeof(errors[property]) === 'object')
                     {
                     errors[property].forEach((obj)=>{
                        this.errors_array.push({erro: obj});
                     });
                     }
                  }
                }
            });
        },
        onUpdate(e)
        {
            this.loading = true;
            this.isDisabled = true;
            this.form.carga = this.carga;
            this.form.seguro = this.seguro;
            this.form.comp_frete = this.comp_frete;
            this.form.modcte_id = this.modcte_id;
            this.form.post('/api/modelocte/update').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        getPortos() {
            this.loading = true;
            this.isDisabled = true;
            this.form.get('/api/porto/jsonlist').then(response =>
            {
                response.items.forEach((obj)=>{
                    this.optionsPortoOrigem.push({ label: obj.cd, value: obj.porto_id })
                });
                response.items.forEach((obj)=>{
                    this.optionsPortoDestino.push({ label: obj.cd, value: obj.porto_id })
                });
                response.items.forEach((obj)=>{
                    this.optionsPortoTransbordo.push({ label: obj.cd, value: obj.porto_id })
                });
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        getEmbarcacao() {
            this.loading = true;
            this.isDisabled = true;
            this.form.get('/api/embarcacao/jsonlist').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.items.forEach((obj)=>
                {
                    this.optionsEmbarcacao.push({ label: obj.nome+' - '+obj.cd, value: obj.embarcacao_id })
                });
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },

        getLivGeral() {
            this.helpForm.get('/api/modelocte/jsonlist').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.cfop.forEach((obj)=>
                {
                    this.optionsCfop.push({ label: obj.cd+" - "+obj.descr, value: obj.cfop_id })
                })

                response.tp_servico.forEach((obj)=>
                {
                    this.optionsLivTpServico.push({ label: obj.valor+" - "+obj.descr, value: obj.valor })
                })
                response.tp_valor_carga.forEach((obj)=>
                {
                    this.optionsLivTpValorCarga.push({ label: obj.descr, value: obj.valor })
                })

                response.globalizado.forEach((obj)=>
                {
                    this.optionsLivGlobalizado.push({ label: obj.descr, value: obj.valor })
                })

                response.municipios.forEach((obj)=>
                {
                    this.optionsMunicipioIni.push({ label: obj.nome+" - "+obj.cd_ibge, value: obj.municipio_id })
                    this.optionsMunicipioFim.push({ label: obj.nome+" - "+obj.cd_ibge, value: obj.municipio_id })
                })
                response.portos.forEach((obj)=>
                {
                    this.optionsPortoOrigem.push({ label: obj.nome+" - "+obj.cd, value: obj.porto_id })
                    this.optionsPortoTransbordo.push({ label: obj.nome+" - "+obj.cd, value: obj.porto_id })
                    this.optionsPortoDestino.push({ label: obj.nome+" - "+obj.cd, value: obj.porto_id })
                })
                response.embarcacao.forEach((obj)=>
                {
                    this.optionsEmbarcacao.push({ label: obj.nome+" - "+obj.irin, value: obj.embarcacao_id })
                })
                response.medida.forEach((obj)=>
                {
                    this.optionsParamUnidadeMedida.push({ label: obj.descr+" - "+obj.cd, value: obj.parunidmed_id })
                })
                response.tipomedida.forEach((obj)=>
                {
                    this.optionsParamTipoMedida.push({ label: obj.descr+" - "+obj.cd, value: obj.partpmed_id })
                })
                response.respseg.forEach((obj)=>
                {
                    this.optionsParamRespSeg.push({ label: obj.descr+" - "+obj.cd, value: obj.partprese_id })
                })
                response.seguradora.forEach((obj)=>
                {
                    this.optionsSeguradora.push({ label: obj.nome+" - "+obj.apolice, value: obj.segurado_id })
                })
                response.custos.forEach((obj)=>
                {
                    this.optionsCustos.push({ label: obj.descr+" - "+obj.cd, value: obj.custo_id })
                })
                response.cst.forEach((obj)=>
                {
                    this.optionsCst.push({ label: obj.cd+" - "+obj.descr, value: obj.parcst_id })
                })
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        listaClientesRemetente(search) {
            if(search.length>=3)
            {
                this.helpForm.search = search;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsRemetente = [];
                    new ReturnApi(response, this, true, false, false);
                    this.isLoadingExp = true;
                    response.items.forEach((obj)=>
                    {
                        this.optionsRemetente.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    this.isLoadingExp = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
        },
        listaClientesExpedidor(search) {
            if(search.length>=3)
            {
                this.helpForm.search = search;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsExpedidor = [];
                    new ReturnApi(response, this, true, false, false);
                    this.isLoadingExp = true;
                    response.items.forEach((obj)=>
                    {
                        this.optionsExpedidor.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    this.isLoadingExp = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
        },
        listaClientesDestinatario(search) {
            if(search.length>=3)
            {
                this.helpForm.search = search;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsDestinatario = [];
                    new ReturnApi(response, this, true, false, false);
                    this.isLoadingExp = true;
                    response.items.forEach((obj)=>
                    {
                        this.optionsDestinatario.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    this.isLoadingExp = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
        },
        listaClientesRecebedor(search) {
            if(search.length>=3)
            {
                this.helpForm.search = search;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsRecebedor = [];
                    new ReturnApi(response, this, true, false, false);
                    this.isLoadingExp = true;
                    response.items.forEach((obj)=>
                    {
                        this.optionsRecebedor.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    this.isLoadingExp = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
        },
        listaClientesExpedidor(search) {
            if(search.length>=3)
            {
                this.helpForm.search = search;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsExpedidor = [];
                    new ReturnApi(response, this, true, false, false);
                    this.isLoadingExp = true;
                    response.items.forEach((obj)=>
                    {
                        this.optionsExpedidor.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    this.isLoadingExp = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
        },
        listaClientesTomador(search) {
            if(search.length>=3)
            {
                this.helpForm.search = search;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsTomador = [];
                    new ReturnApi(response, this, true, false, false);
                    this.isLoadingExp = true;
                    response.items.forEach((obj)=>
                    {
                        this.optionsTomador.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    this.isLoadingExp = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
        },
        limitText (count) {
          return ' e ${count} outros clientes'
        },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito)
        {
            var cnpj_formatado
            var pad = "00000000"
            var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
            var pad = "0000"
            var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
            var pad = "00"
            var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;

            return cnpj_base+""+cnpj_filial+""+cnpj_digito;
        },
        addRowCompFrete: function(e) {
            e.preventDefault();
            this.comp_frete.push({
                custo: "",
                vlr: "",
            });
        },
        removeRowCompFrete: function(index) {
            this.comp_frete.splice(index, 1);
        },
        addRowObsCont: function(e) {
            e.preventDefault();
            this.obs_cont.push({
                xcampo: "",
                xtexto: "",
            });
        },
        removeRowObsCont: function(index) {
            this.obs_cont.splice(index, 1);
        },
        addRowObsFisco: function(e) {
            e.preventDefault();
            this.obs_fisco.push({
                xcampo: "",
                xtexto: "",
            });
        },
        removeRowObsFisco: function(index) {
            this.obs_fisco.splice(index, 1);
        },
        addRowSeguro: function(e) {
            e.preventDefault();
            this.seguro.push({
                seguradora: [],
                partprese: [],
            });
        },
        removeRowSeguro: function(index) {
            this.seguro.splice(index, 1);
        },
        addRowCarga: function(e) {
            e.preventDefault();
            this.carga.push({
                partpmed: [],
                parunidmed: [],
                qtde_carga: 0,
            });
        },
        removeRowCarga: function(index) {
            this.carga.splice(index, 1);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        vuetableFilterRow: {
            get () {
                return this.$store.getters.vuetable.filterRow;
            },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
}
</script>
